import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { canAccess } from "../utils/permissions";

const ProtectedRoute = ({ access, children }) => {
  const { user, loading } = useAuth();


  if (loading) return null;

  if (!user) {
    return <Navigate to="/" replace />;
  }

  if (access && !canAccess(user, access)) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default ProtectedRoute;
